import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { API_BASE } from '../lib/api'
import { Logo } from '../components/Logo'
import '../styles/public-roadmap.css'

type State = 'loading' | 'success' | 'error'

/**
 * One-click SILENCE landing page from Never Out alert emails. Tokenized and anonymous —
 * mirrors the roadmap unsubscribe flow. The API records who silenced the SKU from the
 * recipient address embedded in the token.
 */
export default function NeverOutSilencePage() {
    const { token } = useParams<{ token: string }>()
    const [state, setState] = useState<State>('loading')
    const [message, setMessage] = useState('')

    useEffect(() => {
        if (!token) { setState('error'); setMessage('Invalid silence link.'); return }

        fetch(`${API_BASE}/api/neverout/silence/${token}`)
            .then(async res => {
                const json = await res.json().catch(() => ({}))
                if (res.ok) {
                    setState('success')
                    setMessage(json.message ?? 'This SKU has been silenced.')
                } else {
                    setState('error')
                    setMessage(json.error ?? 'This silence link is invalid or has expired.')
                }
            })
            .catch(() => {
                setState('error')
                setMessage('Could not reach the server. Please try again later.')
            })
    }, [token])

    return (
        <div className="public-roadmap-root">
            <header className="public-roadmap-header">
                <div className="public-roadmap-header-inner">
                    <div className="public-roadmap-brand">
                        <Logo height={24} />
                        <span className="public-roadmap-subtitle">Never Out</span>
                    </div>
                </div>
            </header>

            <main className="public-roadmap-content">
                <div className="confirm-card">
                    {state === 'loading' && (
                        <>
                            <div className="confirm-icon"><div className="spinner" /></div>
                            <h2>Silencing this alert…</h2>
                            <p>Just a moment.</p>
                        </>
                    )}

                    {state === 'success' && (
                        <>
                            <div className="confirm-icon confirm-icon--success">🔕</div>
                            <h2>Alarm silenced</h2>
                            <p>{message}</p>
                            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-tertiary)', marginTop: 'var(--space-3)' }}>
                                Alarms resume automatically if the SKU recovers and crosses its limits again.
                                Signed-in users can un-silence it any time from the Never Out tool.
                            </p>
                            <Link to="/never-out" className="btn btn-primary" style={{ marginTop: 'var(--space-5)' }}>
                                Open Never Out
                            </Link>
                        </>
                    )}

                    {state === 'error' && (
                        <>
                            <div className="confirm-icon confirm-icon--error">⚠️</div>
                            <h2>Link invalid or expired</h2>
                            <p>{message}</p>
                            <Link to="/never-out" className="btn btn-primary" style={{ marginTop: 'var(--space-5)' }}>
                                Open Never Out
                            </Link>
                        </>
                    )}
                </div>
            </main>
        </div>
    )
}
